import { contexts } from 'constants/context';

const contextsThatHideHeader = [contexts.login];
const contextsThatHideSidebar = [contexts.login];

const hideElements = {
  contextsThatHideHeader,
  contextsThatHideSidebar,
};

export default hideElements;
